/**
 * algorithm.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { SubjectContextType } from "../../subjects/subject-context-type";
import { IntakeStep } from "./intake-step";

/**
 * Convert "standard" Advocus algorithm names to more presentable labels
 * @param name Algorithm name in the format "a-[snake-case]"
 */
function humanizeAlgoritmName (name : string) : string
{
  return name.slice(1).replace(
    /-([a-z])/g,
    (_, letter) => ` ${letter.toLocaleUpperCase()}`
  ).slice(1);
}

/**
 * Enumerate algorithm categories that define special behavior.
 */
export enum AlgorithmType
{
  Standard,
  BugReporting
}

/**
 * An {@link Algorithm} is a collection of steps that can be loaded and run by
 * the server's rules engine.
 */
export class Algorithm
{
  public loadedThisSession : boolean = false;

  /**
   * Construct a new {@link Algorithm}
   * @param  {string} name The name the server identifies the algorithm by
   * @return {Algorithm}
   */
  constructor (
    public name : string,
    public contextType : SubjectContextType,
    public displayName : string = humanizeAlgoritmName(name),
    public description : string = "",
    public type : AlgorithmType = AlgorithmType.Standard,
    public supportsIntake : boolean = true,
    public useCustomFlow : string | undefined = undefined
  ) {}
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/algorithms/structure/algorithm.ts